import http from 'utils/http';
import { InboundSipTrunkResponse } from './types';
import { getInboundSipTrunkUrl } from './apiUrls';

export function getInboundSipTrunk(workspaceId: string, agentId: string): Promise<InboundSipTrunkResponse> {
  return http.get(getInboundSipTrunkUrl(workspaceId, agentId));
}

export function createInboundSipTrunk(workspaceId: string, agentId: string, payload: any): Promise<any> {
  return http.post(getInboundSipTrunkUrl(workspaceId, agentId), payload);
}

export function updateInboundSipTrunk(workspaceId: string, agentId: string, payload: any): Promise<any> {
  return http.put(getInboundSipTrunkUrl(workspaceId, agentId), payload);
}

export function deleteInboundSipTrunk(workspaceId: string, agentId: string): Promise<any> {
  return http.delete(getInboundSipTrunkUrl(workspaceId, agentId));
}
